import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { Translations } from '../../../../redux/types';
import { SelectOption, SelectStyle } from '../../../../types/types';
import { trans } from '../../../../utils/trans';

@Component({
  tag: 'rentware-selection-list-multi',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareSelectionListMulti {
  @Prop({ mutable: true }) translations: Translations;
  @Prop({ mutable: true }) locale: string;
  @Event() valuesChange: EventEmitter;
  @Prop() options: SelectOption[];
  @Prop() values: string[];
  @Prop() selectStyle: SelectStyle = SelectStyle.Default;
  @Prop() onExpandedDidLoad: () => void;
  @Prop() onUpdateValues: (any) => void;
  @Prop() onClose: () => void;

  componentDidLoad() {
    this.onExpandedDidLoad();
    if (!this.values) {
      this.values = [];
    }
  }

  handleOptionClick = (e, value) => {
    e.preventDefault();
    this.updateValues(value);
  };

  selectAllOptions = e => {
    if (this.allOptionsAreSelected) {
      e.preventDefault();
      this.onUpdateValues([]);
    } else {
      e.preventDefault();
      this.onUpdateValues(this.options.map(option => option.value));
    }
  };

  get allOptionsAreSelected() {
    return JSON.stringify(this.values?.sort()) === JSON.stringify(this.options.map(option => option.value).sort());
  }

  updateValues = newValue => {
    if (this.values?.includes(newValue)) {
      this.onUpdateValues(this.values?.filter(value => value !== newValue));
    } else {
      this.onUpdateValues([...this.values, newValue]);
    }
  };

  get selectAllLabel(): string {
    return trans(`config.selectAll`, this.locale, this.translations);
  }

  get itemClass(): string {
    return 'ListItem ' + 'ListItem' + this.selectStyle;
  }

  get simpleStyle(): boolean {
    return this.selectStyle === SelectStyle.Simple || this.selectStyle === SelectStyle.Search;
  }

  get labelPriceClass() {
    return 'ListItemPrice ListItemPrice' + this.selectStyle;
  }

  render() {
    return (
      <div class="Wrapper">
        {this.options?.length > 1 && (
          <div class={this.itemClass} onClick={this.selectAllOptions}>
            <CheckBoxButton label={this.selectAllLabel} selectStyle={this.selectStyle} checked={this.allOptionsAreSelected} />
          </div>
        )}

        {this.options?.map(item => {
          return (
            <div class={this.itemClass} onClick={e => this.handleOptionClick(e, item.value)}>
              <CheckBoxButton label={item.label} labelSecondRow={item.labelSecondRow} selectStyle={this.selectStyle} checked={this.values?.includes(item.value)} />

              <span class={this.labelPriceClass}>{item.labelPrice}</span>
            </div>
          );
        })}

        <div class="ConfirmButton">
          <rentware-button appearance={{ fullWidth: true }} buttonText={'Confirm selection'} onClick={this.onClose} />
        </div>
      </div>
    );
  }
}

const CheckBoxButton = ({ label, labelSecondRow = null, selectStyle, checked, ...rest }) => {
  const noIconStyle: boolean = selectStyle === SelectStyle.Simple || selectStyle === SelectStyle.Search || selectStyle === SelectStyle.Config;
  const radioCLass = (noIconStyle && 'LabelContainer LabelContainerSimple') || 'LabelContainer';
  const labelStyle = !!checked ? 'ListItemRow RadioLabelChecked' : 'ListItemRow';

  return (
    <label class={radioCLass} {...rest}>
      <rentware-checkbox checked={checked} fixedStyle={selectStyle === SelectStyle.Config} />

      <div class="SelectRadioLabel">
        <span class={labelStyle}>{label}</span>

        {labelSecondRow && <span class="ListItemRow">{labelSecondRow}</span>}
      </div>

      <input type="radio" checked={checked} name="radio" />
    </label>
  );
};
